if(!customElements.get('custom-event-calendar')){
    class CustomEventCalendar extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.eventCards = this.querySelectorAll('.event-card');

            this.eventCards.forEach(item => {
                var startDate = item.querySelector('.event-card__date--start')? item.querySelector('.event-card__date--start') : null
                var endDate = item.querySelector('.event-card__date--end')? item.querySelector('.event-card__date--end') : null

                this.setDate(startDate);
                this.setDate(endDate);

                if(startDate && endDate){
                    startDate.setAttribute('data-show-from', 'true');
                    endDate.setAttribute('data-show-end', 'true');
                }
            })
        }

        setDate(dateElem){
            if(dateElem === null) return;
            const curDate = dateElem.dataset.date;
            const dateArr = curDate.trim().split('/');

            if(dateArr.length === 2){
                for(let idx=0; idx<dateArr.length; idx++){
                    if(parseInt(dateArr[idx]) !== NaN){
                        const curVal = parseInt(dateArr[idx]);
                        if(idx === 0){ // MM
                            if(curVal > 0 && curVal <= 12){
                                var monthDiv = document.createElement('div');
                                monthDiv.textContent = `${this.convertMonthNumberToAbbrev(curVal)}`;
                                monthDiv.classList.add('month');
                                dateElem.appendChild(monthDiv);
                            }
                        }else{ // DD
                            if(curVal > 0 && curVal <= 31){
                                var dayDiv = document.createElement('div');
                                dayDiv.textContent = `${curVal}`;
                                dayDiv.classList.add('day');
                                dateElem.appendChild(dayDiv)
                            }
                        }
                    }
                }
            }
        }

        convertMonthNumberToAbbrev(monthNumber) {
            const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
            return months[monthNumber - 1];
        }

    }

    customElements.define('custom-event-calendar', CustomEventCalendar);
}